/**
 * External dependencies
 */
import 'preact/debug';

export * from './index';
